import React, { ReactNode, useCallback, useContext, useMemo } from 'react';
import usePersistedState from '../hooks/usePersistedState';
import { authenticate, getStatusSearch } from '../services/api/solucionare';
import { SolucionareErrors } from '../types/enums';

type SolucionareContextProps = {
  children: ReactNode;
};
interface IInitialValues {
  token: string;
  auth: () => Promise<string | SolucionareErrors>;
}
const SolucionareContext = React.createContext({} as IInitialValues);

const SolucionareProvider = ({ children }: SolucionareContextProps) => {
  const [token, setToken] = usePersistedState<string>('tokenSolucionare', '', true);
  const [timeOfAuth, setTimeOfAuth] = usePersistedState<Date | undefined>(
    'timeOfAuth',
    undefined,
    true,
  );

  const auth = useCallback(async () => {
    const response = await authenticate(
      process.env.REACT_APP_RELATIONAL_NAME_SOLUCIONARE || '',
      process.env.REACT_APP_TOKEN_SOLUCIONARE || '',
    );
    if (typeof response === 'string') {
      setToken(response);
      setTimeOfAuth(new Date());
      return response;
    }
    return response;
  }, [setTimeOfAuth, setToken]);

  const contextValues = useMemo(() => ({ auth, token }), [auth, token]);
  return (
    <SolucionareContext.Provider value={contextValues}>{children}</SolucionareContext.Provider>
  );
};
export const useSolucionare = () => useContext(SolucionareContext);
export default SolucionareProvider;
